import { Component, EventEmitter, Output, Input, OnChanges, SimpleChanges, ContentChild, TemplateRef, OnInit, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MAT_SELECT_CONFIG, MatSelectChange } from '@angular/material/select'; 
import { IPlan } from 'src/app/services/plan.service';
import { DurationType, Repetition } from '../../../../../services/external/config/plans';
 

export class DefaultPriceModel{
    plans: IPlan[];
    userPlan: IPlan[];
}

@Component({
    selector: 'default-plan',
    templateUrl: './default-plan.component.html',
    styleUrls: ['./default-plan.component.less']
})
export class DefaultPlanComponent {

    @Input("value") model: DefaultPriceModel; 
    
    showMore: boolean =false;
    repetitionTypes: any = Repetition;
    durationTypes: any = DurationType;
    
}
